import { Tag } from "components/tag";
import { GroupStatusTypes, IEventGroup } from "interfaces";
import moment from "moment";
import { abbreviateNumbers, currencySymbol, formatNumber } from "utills/helpers";

interface EventGroupsCardProps {
  data?: IEventGroup[];
  pageSize: number;
  currentPage: number;
  isLoading: boolean;
  currency?: string;
}

export const EventGroupsCard = ({data = [], pageSize = 10, currentPage = 1, isLoading, currency }: EventGroupsCardProps) => {

  const getGroupStatusText = (statusType: GroupStatusTypes) => {
    switch (statusType) {
      case GroupStatusTypes.CANCELED: return "Canceled";
      case GroupStatusTypes.CLOSED: return "Closed";
      case GroupStatusTypes.OPENING: return "Opening";
      case GroupStatusTypes.SENDPAYMENT: return "Send Payment";
      case GroupStatusTypes.SUCCESS: return "Success";
      default: return "";
    }
  }

  return (
    <ul className="bg-white">
      {data.map((item: IEventGroup, index: number) => (
        <div key={index} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              No
            </p>
            <p className="flex-1 text-right text-sm leading-6">{(currentPage - 1) * pageSize + 1 + index}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Group name
            </p>
            <p className="flex-1 text-right text-sm leading-6">{item.name_en}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Members
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.attendant_quantity)}
            >
              {abbreviateNumbers(item.attendant_quantity)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Paid
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.attendant_paid_quantity)}
            >
              {abbreviateNumbers(item.attendant_paid_quantity)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Gross revenue
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.total_amount)}
            >
              {currencySymbol(currency)} {abbreviateNumbers(item.total_amount)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Discount
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.discount_amount)}
            >
              {currencySymbol(currency)} {abbreviateNumbers(item.discount_amount)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Net revenue
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.final_amount)}
            >
              {currencySymbol(currency)} {abbreviateNumbers(item.final_amount)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Expired date time
            </p>
            <p className="flex-1 text-right text-sm leading-6">{item.expired_date ? moment(item.expired_date).format("DD/MM/YYYY HH:mm:ss") : ""}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Status
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              <Tag text={getGroupStatusText(item.group_status)} type={item.group_status}  />
            </p>
          </li>
        </div>
      ))}
    </ul>
  )
}